<template>
  <div id="app">
    <Messages />
  </div>
</template>

<script>
import Messages from "./components/Messages.vue";

export default {
  name: "App",
  components: {
    Messages,
  },
};
</script>
